module.exports = __webpack_public_path__ + "static/media/roman-rieunier-cv.63d0f2be.pdf";